import React from 'react';
import { Link } from 'react-router-dom';
import { FiBookOpen, FiChevronLeft } from 'react-icons/fi';
export default function TrainingRecordHeader({ title, subtitle, children }) {
  return <header className="space-y-4"><Link to="/staff-training" className="inline-flex items-center gap-1 text-sm font-semibold text-blue-600"><FiChevronLeft /> Staff Training</Link>
    <div className="flex flex-wrap items-center justify-between gap-4"><div className="flex items-center gap-4"><div className="rounded-xl bg-blue-600 p-3 text-white"><FiBookOpen className="h-7 w-7" /></div>
      <div><h1 className="text-2xl font-bold text-slate-900">{title}</h1><p className="mt-1 text-sm text-slate-500">{subtitle}</p></div></div>{children}</div>
  </header>;
}
